"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserBtnItem = void 0;
const react_1 = __importStar(require("react"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const user_btn_styles_1 = require("./user-btn-styles");
exports.UserBtnItem = (0, react_1.forwardRef)(function UserBtnItem({ action: { label, action, href }, onClose }, ref) {
    const classes = (0, user_btn_styles_1.useStyles)();
    const handleClick = (0, event_callback_hook_1.useEventCallback)(() => {
        if (action !== undefined) {
            action();
            onClose();
        }
    });
    return (react_1.default.createElement(MenuItem_1.default, { component: href ? 'a' : 'div', href: href, ref: ref, onClick: handleClick },
        react_1.default.createElement(ListItemText_1.default, { className: classes.listItemText, primary: label })));
});
//# sourceMappingURL=user-btn-item.js.map